import { QueryParams } from "@/models/query-params.model";
import { CrawlerRest } from "@/services/rest/crawler.rest";
import { BehaviorSubject, lastValueFrom } from "rxjs";

export class CrawlerService {
  constructor(private _crawler = new CrawlerRest()) {}

  private data$ = new BehaviorSubject([]);
  data = this.data$.asObservable();

  async getIndexedVideos(params?: QueryParams): Promise<any> {
    const data$ = this._crawler.getIndexedVideos(params);
    return (this.data = await lastValueFrom(data$));
  }
}
